import "bootstrap-icons/font/bootstrap-icons.css";

import EnquiryForm from "components/forms/EnquiryForm";
import { Jumbotron } from "sections";
import { ShariahItem } from "components/pf";
import { ASSETS_BASE_URL } from "constants";

import pf_pds from "assets/pdf/property-financing/PDS-BPF_effective28Nov2023.pdf";
import AccordionSimple from "components/accordion/AccordionSimple";
import { FaqListBusinessPremiseFinancing } from "constants/faq";
import Benefits from "components/benefits";
import Icon from "assets/images/line_icons.svg";
import PropertyEligibility from "components/eligibility/PropertyEligibility";
import FeesAndCharges from "components/fee&charges/FeesAndCharges";

import Financing from "assets/images/hero-images/Banner_Financing.png";
import BG from "assets/images/hero-images/BG.png";

function BusinessFinancing() {
  const pfBenefitsData = [
    {
      title: (
        <>
          <b>Financing Rate</b>
        </>
      ),
      content: (
        <p className="benefits-content-text">Competitive financing rates</p>
      ),
      delay: "100",
    },
    {
      title: (
        <>
          <b>Financing</b>
        </>
      ),
      content: (
        <p className="benefits-content-text">Margin of financing up to 85%</p>
      ),
      delay: "200",
    },
    {
      title: (
        <>
          <b>Tenure</b>
        </>
      ),
      content: (
        <p className="benefits-content-text">Tenures of up to 25 years</p>
      ),
      delay: "300",
    },
    {
      title: (
        <>
          <b>Takaful Coverage</b>
        </>
      ),
      content: (
        <p className="benefits-content-text">
          Comprehensive Takaful coverage provided
        </p>
      ),
      delay: "300",
    },
  ];
  const pfBenefitsConfig = {
    heading: "Benefits",
    tnc: "*Terms & Conditions apply",
    // faq: "FAQ",
    benefitsData: pfBenefitsData,
    desktopImages: `${ASSETS_BASE_URL}assets/images/pf/shahrul.svg`,
    mobileImage: `${ASSETS_BASE_URL}assets/images/pf/shahrul.svg`,
    tncLink: "/tnc",
  };

  const pfEligibility = {
    type: "pf",
    title: "Apply easily",
    steps: 2,
    highlightedText: "in just 2 steps",
    documentsTitle: "Required Documents",
    employeeType: "",
    horizontalTable: true,
    yearsOld: "years old",
    documents: [
      {
        title: "<span>Salaried employees</span>",
        content:
          "<ul><li>Photocopy of <b>IC / Identification document</b></li><li>Latest <b>3 months salary slip</b> and <b>personal bank statement</b> reflecting salary crediting</li><li>Latest <b>EPF statement</b></li><li>Sales & <b>Purchase Agreement</b> / Booking receipt</li></ul>",
        backgroundColor: "#DCE9FF",
      },
      {
        title: "<span>Self-employed</span>",
        content:
          "<ul><li>Photocopy of <b>IC / Identification document</b></li><li>Latest <b>6 months bank statement</b></li><li><b>Business Registration Document</b></li><li>Copy of <b>Income Tax</b> & proof of tax payment</li><li>Sales & <b>Purchase Agreement</b> / Booking receipt</li></ul>",
        backgroundColor: "#F2F4F7",
      },
    ],
    eligibilityTitle: "Eligibility",
    eligibility: [
      {
        title:
          "<ul><li><strong>Malaysians and non-Malaysians (T&C apply)</strong></li></ul>",
        content:
          "<ul><li><strong>Individual aged 21 years & up to 65 years)</strong></li></ul>",
        backgroundColor: "#DCE9FF",
      },
    ],
  };

  const pfFeesAndCharges = {
    type: "pf",
    title: "Fees & Charges",
    documents: [
      {
        title: "Retrieval / Photocopy of Security Documents",
        content: "Actual Cost",
      },
      {
        title: "EPF Withdrawal Confirmation Letter Fee",
        content: "RM10.00 per request",
      },
      {
        title: "Annual Financing Statement Fee",
        content: "RM 5.00 per request (Ad-hoc)",
      },
      {
        title: "Redemption Statement Fee",
        content: "RM 10.00 per request",
      },
      {
        title: "Brokerage Fee",
        content: "0.0008% of the principal amount of financing/disbursement",
      },
      {
        title: "ARNT Fee (or Agency Fee)",
        content: "RM 1.00 per transaction",
      },
    ],
    buttons: [
      {
        title: "Product Disclosure Sheet",
        link: pf_pds,
      },
      {
        title: "Download Application Form",
        link: `${ASSETS_BASE_URL}assets/pdf/personal-financing/HF_Application_Form.pdf `,
      },
    ],
  };

  const FaqListPFHome = [
    {
      id: 0,
      title: "What is the Shariah contract applicable?",
      content: "The applicable Shariah contract is Commodity Murabahah.",
    },
    {
      id: 1,
      title: "What is the minimum and maximum tenure?",
      content:
        "The financing tenure is ranging from minimum 5 years up to 35 years, subject to terms and conditions.",
    },
    {
      id: 2,
      title: "What is the minimum and maximum financing amount?",
      content: "The Minimum financing amount is RM50,000.",
    },
    {
      id: 3,
      title: "Is Mortgage Reducing Term Takaful (MRTT) coverage compulsory?",
      content:
        "The Mortgage Reducing Term Takaful (MRTT) coverage is optional.",
    },
    {
      id: 4,
      title:
        "<span>How to apply Home <span className='no-wrap'>Financing-<i>i</i> ?</span></span>",
      content:
        "<p>You may walk-in to the nearest branch, or contact our call centre at +603 2332 6000, or share your contact details in this link <a className='no-wrap' href='https://www.alrajhibank.com.my/enquiry'>Product Enquiry</a> , our bank representative will contact to assist you.</p>",
    },
    {
      id: 5,
      title: "How do I pay for the monthly installment?",
      content:
        "You are required to deposit the monthly instalment in your financing account on or before its due date until the full settlement of the financing.",
    },
    {
      id: 6,
      title: "What if I fully settle the financing before its maturity?",
      content:
        "<p>You may opt to fully settle the financing prior to the maturity date. If the facility is settled within first 5 years from the date of the first disbursement, the Bank shall have the right to claim actual entry costs (if any).</p><p>Rebate will be granted by the Bank in accordance with Bank Negara Malaysia Guidelines and our internal rebate (Ibra’) guideline.</p><p>The customer may at any time after the completion of each Sale transaction pay the entire amount of the Bank Sale price or any part thereof then owing to the Bank as the Bank may in absolute discretion accept.</p>",
    },
    {
      id: 7,
      title: "How do I contact alrajhi bank Malaysia?",
      content:
        "<p>For more information, kindly contact one of our 24-Hour Customer Care Consultants using your preferred method below:</p><p>+603 2332 6000</p><p>customersupport@alrajhibank.com.my</p>",
    },
  ];

  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Property Financing-i"
          title={`  <span className="jumbotron-subtitle-2">
                Business Premise
              </span>
               Financing
             `}
          buttonText="Let's connect! "
          backgroundImage={Financing}
          uniqueBg={BG}
        />
      </section>

      <section className="section about container">
        <div className="row pf-page" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3 className="general-header">About</h3>
          </div>
          <div className="col-xl-8">
            <p className="about-text">
              Al Rajhi Home Financing-<em>i</em> assists you in buying your
              business premises with peace of mind. We offer attractive
              financing rate with tenure up to 25 years.
            </p>
          </div>
        </div>
      </section>
      <Benefits {...pfBenefitsConfig} />

      <section className="section about container">
        <ShariahItem
          header={<span>Shariah Contract</span>}
          subheader="Commodity Murabahah (via Tawarruq arrangement)"
          Icon={Icon}
        />
      </section>
      <PropertyEligibility {...pfEligibility} />
      <FeesAndCharges {...pfFeesAndCharges} />
      {/* <section className="section about container">
        <div className="d-flex justify-content-center p-5 mb-5" data-aos="zoom-in">
          <h1>Frequently Asked Questions</h1>
        </div>
        <div className="mx-5">
          <AccordionSimple data={FaqListBusinessPremiseFinancing} />
        </div>
      </section>
      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4 d-xl-block d-none">
            <h3>Let's connect!</h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section> */}
    </div>
  );
}

export default BusinessFinancing;
